import Vue from "vue";
import Vuetify from "vuetify/lib";
import colors from "vuetify/es5/util/colors";
import es from "vuetify/src/locale/es";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#00978A",
        secondary: "#ED8B49",
        accent: colors.orange.accent2,
        error: colors.deepOrange.base,
        warning: colors.amber.base,
        info: colors.indigo.base,
        success: colors.teal.base,
      },
    },
  },
  lang: {
    locales: { es },
    current: "es",
  },
});
